import { useState } from "react";
import {
  OnboardingFlow,
  buildChecklistResult,
  type OnboardingPayload,
  type OnboardingResult,
} from "@ascleo/frontdesk-shared/onboarding";

async function fetchChecklist(payload: OnboardingPayload) {
  return buildChecklistResult({
    generalApiReachable: true,
    telematikAvailable: true,
    selectedCardReaderAvailable: true,
    hasMedicalCard: true,
    practiceName: "Praxis Weber",
    deviceName: "Empfang 1",
    serverTokenConfigured: payload.solToken.length > 0,
    insuiteRestUrl: payload.insuiteRestUrl,
    revoked: false,
  });
}

/**
 * E2E-only harness that mounts the onboarding wizard with a deterministic mock
 * checklist and no camera scanner (manual connection fallback), so the wizard's
 * user-visible behavior can be proven without a bridge/Mongo stack.
 *
 * Reachable only at the explicit `/onboarding-e2e` path.
 *
 * @since 0.0.0
 */
export function OnboardingE2EHarness(): React.ReactElement {
  const [done, setDone] = useState<OnboardingResult | null>(null);

  if (done) {
    return (
      <div data-testid="frontdesk-onboarding-e2e-complete" className="p-10">
        Paired: {done.deviceName} · PIN set
      </div>
    );
  }

  return (
    <OnboardingFlow fetchChecklist={fetchChecklist} onComplete={setDone} />
  );
}
